<template>
  <div>
    <transition name="content-fade" mode="out-in">
      <div v-if="loading" key="loading" class="row">
        <div class="col-md-3">
          <SkeletonSummary />
        </div>
        <div class="col-md-9">
          <SkeletonReportGroup />
          <SkeletonReportGroup />
        </div>
      </div>
      <div v-else-if="error" key="error" class="alert alert-danger">
        {{ error }}
      </div>
      <div v-else key="content" class="row">
        <div class="col-md-3">
          <ReportGroupSummary :report-groups="reportGroups" />
        </div>
        <div class="col-md-9">
          <ReportGroup 
            v-for="(group, index) in reportGroups" 
            :key="group.id"
            :group="group"
            :class="`fade-in-subtle fade-in-stagger-${Math.min(index + 1, 5)}`"
            @item-removed="handleItemRemoved"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ReportGroupSummary from './ReportGroupSummary.vue'
import ReportGroup from './ReportGroup.vue'
import SkeletonSummary from './SkeletonSummary.vue'
import SkeletonReportGroup from './SkeletonReportGroup.vue'

export default {
  name: 'ReportGroups',
  components: {
    ReportGroupSummary,
    ReportGroup,
    SkeletonSummary,
    SkeletonReportGroup
  },
  props: {
    quotationId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      reportGroups: [],
      loading: false,
      error: null
    }
  },
  async created() {
    await this.fetchReportGroups()
  },
  methods: {
    async fetchReportGroups() {
      this.loading = true
      this.error = null
      
      try {
        const response = await fetch(`/quotations/${this.quotationId}/report_groups.json`)
        
        if (response.status === 404) {
          // No report group items found - redirect to quotation show page
          window.location.href = `/quotations/${this.quotationId}`
          return
        }
        
        if (!response.ok) {
          throw new Error('Failed to fetch report groups')
        }
        
        const data = await response.json()
        this.reportGroups = data.quotation.report_groups || []
      } catch (error) {
        this.error = error.message
        console.error('Error fetching report groups:', error)
      } finally {
        this.loading = false
      }
    },
    async handleItemRemoved(itemId) {
      // Refresh the entire dataset to get updated statistics
      await this.fetchReportGroups()
      
      // Check if there are no more report groups or all groups are empty
      const hasItems = this.reportGroups.some(group => 
        group.report_group_items && group.report_group_items.length > 0
      )
      
      if (!hasItems) {
        // Redirect to quotation show page when no items remain
        window.location.href = `/quotations/${this.quotationId}`
      }
    }
  }
}
</script>